<template>
<div class="container_my">
    <nav id="weather">
        Weather
    </nav>
</div>
</template>
<script>
export default({
    name:'NavBar'
})
</script>


<style scoped>
#weather{
  color:white;
  text-align: center;
  height:40px;
  font-weight: 700;
  font-family: sans-serif;
  font-size:30px;
  padding:13px;
}
.container_my{
    margin:0 auto;
}
</style>